// SearchTab.js
import React, { useEffect, useState } from 'react';
import { getToken } from '../../../utils/TokenUtils';
import { API_URL } from '../../../constants/api';

export default function SearchTab({ table }) {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState('');
  const [operator, setOperator] = useState('=');
  const [value, setValue] = useState('');
  const token = getToken(); // Or get it from auth context

  const [filters, setFilters] = useState([]);
  const [results, setResults] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/sql/tables/${table}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log('res:', res);
        if (res?.columns?.length) {
          setColumns(res.columns);
          setData(res.rows);
          setSelectedColumn(res.columns[0]);

          setResults(res.rows); // optionally show all initially
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Failed to load data');
      });
  }, [table]);

  console.log('filters:', filters);

  const operators = ['=', 'LIKE', '!=', '>', '<'];

  const handleFilterChange = (column, field, value) => {
    setFilters((prevFilters) => {
      const existing = prevFilters.find((f) => f.column === column);
      if (existing) {
        // update field
        const updated = prevFilters.map((f) =>
          f.column === column ? { ...f, [field]: value } : f
        );
        return updated.filter((f) => f.operator || f.value); // remove if both empty
      } else {
        // add new
        return [
          ...prevFilters,
          {
            column,
            operator: field === 'operator' ? value : '',
            value: field === 'value' ? value : '',
          },
        ];
      }
    });
  };

  const handleSearch = () => {
    const filtered = data.filter((row) =>
      filters.every(({ column, operator, value }) => {
        if (!operator || value === '') return true;

        const cell = (row[column] ?? '').toString().toLowerCase();
        const input = value.toLowerCase();

        switch (operator) {
          case '=':
            return cell === input;
          case '!=':
            return cell !== input;
          case 'LIKE':
            return cell.includes(input);
          case '>':
            return cell > input;
          case '<':
            return cell < input;
          default:
            return true;
        }
      })
    );

    setResults(filtered);
  };

  if (!columns?.length) return <p>Loading...</p>;

  return (
    <div>
      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle">
          <thead>
            <tr>
              <th>Column</th>
              <th>Operator</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {columns.map((col, index) => {
              const filter = filters.find((f) => f.column === col) || {
                operator: '',
                value: '',
              };

              return (
                <tr key={col}>
                  <td>{col}</td>
                  <td>
                    <select
                      className="form-select"
                      value={filter.operator}
                      onChange={(e) =>
                        handleFilterChange(col, 'operator', e.target.value)
                      }
                      style={{ maxWidth: '120px' }}
                    >
                      <option value="">--</option>
                      {operators.map((op) => (
                        <option key={op} value={op}>
                          {op}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(col, 'value', e.target.value)
                      }
                      placeholder="Enter value"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-end">
        <button className="btn btn-primary btn-sm" onClick={handleSearch}>
          🔍 Search
        </button>
      </div>

      <div className="table-responsive mt-3">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {results.map((row, i) => (
              <tr key={i}>
                {columns.map((col) => (
                  <td key={col}>{row[col]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {results.length === 0 && (
        <p className="text-muted mt-3">No results found.</p>
      )}
    </div>
  );
}
